var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
export function getClassifierNames(classifier_1, ids_1) {
    return __awaiter(this, arguments, void 0, function* (classifier, ids, delimiter = ',') {
        if (Array.isArray(ids)) {
            if (ids.length === 0) {
                return '';
            }
            let names = '';
            yield Promise.all(ids.map((id) => __awaiter(this, void 0, void 0, function* () { return (yield new StorageClient(classifier).get(id)).data.name; }))).then((values) => {
                names = values.join(delimiter);
            });
            return names;
        }
        if (typeof ids === 'string') {
            return (yield new StorageClient(classifier).get(ids)).data.name;
        }
        return '';
    });
}
